var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelClosing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 9.5,
    fill: "#FFEBEE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 9.5,
    stroke: "#F44336"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2221_6488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2113 11.5446L12.6725 12.0833L13.2113 12.6221C13.3742 12.785 13.3742 13.0483 13.2113 13.2113C13.13 13.2925 13.0233 13.3333 12.9167 13.3333C12.81 13.3333 12.7033 13.2925 12.6221 13.2113L12.0833 12.6725L11.5446 13.2113C11.4633 13.2925 11.3567 13.3333 11.25 13.3333C11.1433 13.3333 11.0367 13.2925 10.9554 13.2113C10.7925 13.0483 10.7925 12.785 10.9554 12.6221L11.4942 12.0833L10.9554 11.5446C10.7925 11.3817 10.7925 11.1183 10.9554 10.9554C11.1183 10.7925 11.3817 10.7925 11.5446 10.9554L12.0833 11.4942L12.6221 10.9554C12.785 10.7925 13.0483 10.7925 13.2113 10.9554C13.3742 11.1183 13.3742 11.3817 13.2113 11.5446ZM15 12.0833C15 13.6912 13.6912 15 12.0833 15C10.4754 15 9.16667 13.6912 9.16667 12.0833C9.16667 10.4754 10.4754 9.16667 12.0833 9.16667C13.6912 9.16667 15 10.4754 15 12.0833ZM14.1667 12.0833C14.1667 10.9346 13.2321 10 12.0833 10C10.9346 10 10 10.9346 10 12.0833C10 13.2321 10.9346 14.1667 12.0833 14.1667C13.2321 14.1667 14.1667 13.2321 14.1667 12.0833ZM9.16667 14.5833C9.16667 14.8137 8.98042 15 8.75 15H7.08333C5.93458 15 5 14.0654 5 12.9167V7.08333C5 5.93458 5.93458 5 7.08333 5H8.96458C9.74333 5 10.4758 5.30333 11.0271 5.85417L12.0692 6.89667C12.4408 7.2675 12.7046 7.72875 12.8329 8.23C12.8646 8.35458 12.8375 8.48708 12.7583 8.58875C12.6792 8.69042 12.5579 8.75 12.4292 8.75H10.2975C9.67417 8.75 9.16667 8.2425 9.16667 7.61917V5.84292C9.1 5.83667 9.0325 5.83333 8.96458 5.83333H7.08333C6.39417 5.83333 5.83333 6.39417 5.83333 7.08333V12.9167C5.83333 13.6058 6.39417 14.1667 7.08333 14.1667H8.75C8.98042 14.1667 9.16667 14.3529 9.16667 14.5833ZM10 7.61917C10 7.78333 10.1333 7.91667 10.2975 7.91667H11.8121C11.7217 7.76083 11.6104 7.61583 11.48 7.48625L10.4379 6.44375C10.3054 6.31125 10.1583 6.19917 10 6.10833V7.61917Z",
    fill: "#FF0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2221_6488"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelClosing);
export default __webpack_public_path__ + "static/media/CancelClosing.30376ba6.svg";
export { ForwardRef as ReactComponent };